import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';
import { PlatformDataType } from 'hooks/api/usePlatform';

export type createPlatformDataType = {
  errorCallback?: Function;
  resultKey?: string;
  successCallback?: Function;
  parameters: PlatformDataType;
};

export default ({
  successCallback,
  errorCallback,
  resultKey = 'createPlatformData',
  parameters,
}: createPlatformDataType) =>
  requestAsync({
    url: endpoints.getRevenueSourcesUrl(),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getRevenueSourcesUrl(),
    body: parameters,
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
